import { render, staticRenderFns } from "./PerformanceObjectives.vue?vue&type=template&id=a3bdb770&scoped=true"
import script from "./PerformanceObjectives.vue?vue&type=script&lang=js"
export * from "./PerformanceObjectives.vue?vue&type=script&lang=js"
import style0 from "./PerformanceObjectives.vue?vue&type=style&index=0&id=a3bdb770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bdb770",
  null
  
)

export default component.exports